import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import EventEmitter, {
  SHOW_POPUP_FOLLOW_ALERT,
  SHOW_POPUP_UPGRADE,
} from '../../../../../helpers/EventEmitter'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../../../layout/store/slice'
import { AUTHORIZATION_TYPE } from '../../../../../utils/authorization'
import classes from './index.module.scss'

export const FollowBtn = ({ isFollowed }) => {
  const userType = useSelector(selectUserType)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)

  const isDisable =
    AUTHORIZATION_API.companyAnalysis.followAlerts[userType.userTypeId] ===
    AUTHORIZATION_TYPE.DISABLE

  const onClick = () => {
    if (isDisable) {
      EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
    } else {
      EventEmitter.dispatch(SHOW_POPUP_FOLLOW_ALERT, true)
    }
  }

  return (
    <div className={classes.container}>
      <Element
        elementName="button"
        className={classes.button}
        style={{ backgroundColor: '#3DA967', color: '#FFFFFF' }}
        onClick={onClick}
      >
        <Icon className={['icon-follow', classes.followIcon].join(' ')} />
        <Translate
          value={`${
            isFollowed
              ? 'companyAnalysis.common.FOLLOWING'
              : 'companyAnalysis.common.FOLLOW'
          }`}
        />

        {isDisable && (
          <Icon className={['icon-lock', classes.lockIcon].join(' ')} />
        )}
      </Element>
    </div>
  )
}

FollowBtn.propTypes = {
  isFollowed: PropTypes.bool,
}
